import colors from '@rategravity/frontend/theme/colors';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import DownArrow from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
import React from 'react';

const style = {
  enabled: {
    fill: colors.white
  },
  disabled: {
    fill: colors.white
  }
};

export default (props) => (
  <FloatingActionButton
    backgroundColor={colors.secondary}
    iconStyle={props.disabled ? style.disabled : style.enabled}
    disabled={props.disabled}
    onClick={props.onSubmit}
  >
    <DownArrow />
  </FloatingActionButton>
);



// WEBPACK FOOTER //
// ./src/components/card/next-button.js